export const HOME_ROUTE:string = "/";
export const JOBS_ROUTE:string = "/jobs";
export const JOB_ROUTE:string = "/job";
export const SELECTED_ROUTE:string = "/selected"
